import React, { useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import verifyToken from "../middleware/auth";
import { Sidebar } from "./Sidebar/Sidebar";
import Header from "./Header";
import Footer from "./Footer";

const offsets = ["/apps/file-manager", "/apps/email", "/apps/calendar"];

export default function Main() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    verifyToken();
  }, []);

  const bc = document.body.classList;

  // set sidebar to offset
  offsets.includes(pathname)
    ? bc.add("sidebar-offset")
    : bc.remove("sidebar-offset");

  // auto close sidebar when switching pages in mobile
  bc.remove("sidebar-show");

  // scroll to top when switching pages
  window.scrollTo(0, 0);

  return (
    <React.Fragment>
      <Sidebar />
      <Header />
      <Outlet />
      <Footer />
    </React.Fragment>
  );
}
